import {useIssueCreateMetadata} from '@github-ui/issue-create/IssueCreateDataContext'
import isEqual from 'lodash-es/isEqual'

import type {DraftIssue} from '../content-preview-types'
import {useDraftIssueFormSync} from './use-draft-issue-form-sync'
import {useOnChangeCallback} from './use-on-change-callback'
import {useProjectsQuery} from './use-projects-query'

export function useDraftIssueProjects(draftIssue: DraftIssue) {
  const {repository: formRepository, projects: formProjects, setProjects: setFormProjects} = useIssueCreateMetadata()
  const onChange = useOnChangeCallback(draftIssue)

  return useDraftIssueFormSync(draftIssue, {
    draftValue: draftIssue.projects,
    formValue: formProjects,
    setFormValue: setFormProjects,
    onChange: (newValue, skipVersionBump) =>
      onChange({projects: newValue.map(p => ({id: p.id, title: p.title}))}, skipVersionBump),
    resolverResult: useProjectsQuery({
      owner: formRepository?.owner.login,
      repo: formRepository?.name,
      projects: draftIssue.projects ?? [],
    }),
    hasPermission: repo => repo?.viewerIssueCreationPermissions?.triageable,
    isEqual,
    defaultValue: [],
  })
}
